import React from "react";
import { Link } from 'react-router-dom'

import Container from '../../components/Container'
import Hero from '../../components/Hero'
import Header from '../../components/Header/brandbook'
import Section from '../../components/Section'
import Ident from '../../components/Ident'
import Icon from '../../components/Icon'
//import DynamicLogoInput from '../../components/DynamicLogoInput'
import Downloadable from '../../components/Downloadable'
import DemoWrapper from '../../components/DemoWrapper'
import IconDemo from '../../components/IconDemo'
import Grid from '../../components/Grid'

export const path = '/brandbook/logo'

export default function BrandbookPage() {
  return (
    <div className="light">
      <Header />
      <Hero>
        <Container size="large">

          <Grid grid="1-2">
            <></>
            <>
              <h1><span className="highlight">Tools and Rules</span> <br />Logotype</h1>
            </>
          </Grid>
        </Container>

      </Hero>
      <Container size="large">


      <Section>

      <Grid grid="1-2">
        <></>
        <>

          <p>
            Our logo is one of the most recognizable visual elements in our toolset. Depending on media and context it adapts in both form, function and colors without becoming any less recognizable as a representative for the Waved brand.
          </p>

          <h2>Symbol and textmark</h2>
          <p>
            The organic sine wave is a visualization of our core business as well as the the letter W from our name. It works well as a fixed shape for static media, but really comes to life in the digital universe.
          </p>

          <p>
            The textmark is set in our typeface Karelia, and aligned to the center of the symbol.
          </p>
        </>
      </Grid>
      </Section>


      <Section>
          <DemoWrapper aspect="3/2" light description="Primary logo set on a Blue steel solid. Use it in external channels and on bright backgrounds. ">
            <Ident xlarge light>
              <svg viewBox="0 0 80 80">






                <rect x="0" width="80" height="80" id="background" />
                <path id="w" d="M2.5,20.7h2h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0h2" />


              </svg>


            </Ident>


          </DemoWrapper>
          </Section>


          <Section>
            <DemoWrapper aspect="3/2" dark description="Secondary logo on a Dark Space solid. Only use this version on dark backgrounds and when we have full control of application, channel or context. ">
              <Ident xlarge>
                <svg viewBox="0 0 80 80">






                  <rect x="1" width="78" height="78" id="background" />
                  <path id="w" d="M2.5,20.7h2h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0h2" />


                </svg>


              </Ident>


            </DemoWrapper>

            </Section>

        <Section>

          <Grid grid="1-2">
            <></>
            <>
              <h2>Dynamic and contextual</h2>
              <p>In digital media the logo comes to life with the help of animation and data. We reveal, preload and animate it based on context and user flow. </p>
            </>
          </Grid>
        </Section>

                {/*<DemoWrapper aspect="3/2" dark description="Dynamic logo with sound input as data source. In this case the browser microphone. ">
                  <Ident xlarge>
                    <DynamicLogoInput />

                    <svg viewBox="0 0 80 80">
                      <rect x="1" width="78" height="78" id="background" />
                    </svg>
                  </Ident>
                </DemoWrapper>
                */}
      <Section>
      <Grid>
        <DemoWrapper aspect="1/1" dark description="Logo reveal. ">
            <div className="bb-logo-animation--is-active">
                  <Ident xlarge symbol animate>
                    <svg viewBox="0 0 80 80">

                      <rect x="1" width="78" height="78" id="background" />

                      <path id="w" d="M2.5,20.7h2h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0h2" />

                    </svg>
                  </Ident>
                </div>

              </DemoWrapper>

              <DemoWrapper aspect="1/1" dark description="Symbol as preloader.">
                <Ident xlarge preloader symbol>
                  <svg viewBox="0 0 80 80">

                    <rect x="1" width="78" height="78" id="background" />

                    <path id="w" d="M2.5,20.7h2h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0c3.7,0,6.9,2.7,7.5,6.4l4,25.7c0.6,3.7,3.8,6.4,7.5,6.4h0c3.7,0,6.9-2.7,7.5-6.4l4-25.7 c0.6-3.7,3.8-6.4,7.5-6.4h0h2" />

                  </svg>

                </Ident>


                          </DemoWrapper>








</Grid>



      </Section>

      <Section>

      <Grid grid="1-2">
        <></>
        <>
          <h2>Logo files</h2>

          <Downloadable>
            <IconDemo><Icon icon="download" /></IconDemo>
            <div className="downloadable__content">
              <h3><a href="https://drive.google.com/file/d/1XljdChivnnTiTxiQyrDD-tu5Z0VmAfZb" target="_blank" rel="noopener noreferrer">Primary full</a></h3>
              <p>Waved_primary-full.eps</p>
            </div>
          </Downloadable>

          <Downloadable>
            <IconDemo><Icon icon="download" /></IconDemo>
            <div className="downloadable__content">
            <h3><a href="https://drive.google.com/file/d/1Xq-YG2yDRsnp-aTBVz62smNKJMhFuUAd" target="_blank" rel="noopener noreferrer">Secondary full</a></h3>
            <p>Waved_secondary-full.eps</p>
            </div>
          </Downloadable>

      </>
    </Grid>

  </Section>

    <br />
    </Container>
    </div>
    )
  }
